import type { FetchResult } from '@apollo/client';
import log from 'loglevel';

const messages = {
  success: '🎉 Mutation completed successfully:',
  error: '💥 Mutation failed:',
};

export function logMutationResponse(result: FetchResult<unknown>): void {
  if (result.data) {
    log.info(messages.success, result);
  } else if (result.errors && result.errors.length > 0) {
    log.error(messages.error, result);
  } else {
    log.error(messages.error, result);
  }
}
